import Icon from "@ant-design/icons"
import React from "react"
import { IconBox } from "./IconBox"

interface DiamondSvgProps {
    width?: number
    height?: number
}

const DiamondSvg = ({ width, height }: DiamondSvgProps) => (
    <svg className="m-0" width={width ?? 12} height={height ?? 10} viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2541_13016)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5508 2.56143L9.30119 0.41857C9.16321 0.286459 8.9983 0.181395 8.81613 0.109515C8.63396 0.0376344 8.43823 0.000388781 8.2404 0H3.74115C3.54333 0.000388781 3.3476 0.0376344 3.16543 0.109515C2.98326 0.181395 2.81832 0.286459 2.68034 0.41857L0.430727 2.56143C0.163219 2.81879 0.00739521 3.15931 -0.00675678 3.51737C-0.0209088 3.87543 0.107631 4.22573 0.354098 4.50073L4.85333 9.50073C4.99206 9.65693 5.16607 9.78264 5.36295 9.86895C5.55983 9.95526 5.77473 10 5.99231 10C6.20989 10 6.42479 9.95526 6.62167 9.86895C6.81855 9.78264 6.99256 9.65693 7.13129 9.50073L11.6305 4.50073C11.8766 4.22538 12.0046 3.87487 11.9899 3.5168C11.9752 3.15873 11.8188 2.81843 11.5508 2.56143ZM6.74422 4.28571L5.9946 8.57143L1.49537 3.57143L5.24499 4.28571L3.74499 1.42857H8.24422L10.4938 3.57143L6.74422 4.28571Z"
                fill="#3886FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_2541_13016">
                <rect width={12} height={10} fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const DiamondIcon = (props: Omit<React.ComponentProps<typeof Icon>, "component"> & DiamondSvgProps) => (
    <Icon component={() => <DiamondSvg width={props.width} height={props.height} />} {...props} />
)

export const DiamondBoxedBlueIcon = () => <IconBox icon={<DiamondIcon />} classNames="bg-finway-blue bg-opacity-10" />
